import React from 'react';
import { useHistory, useLocation } from "react-router-dom"
import { CssBaseline, AppBar, Toolbar, Link, Typography, Grid } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import logo from '../resources/cconline48.png'
const path = [
    { pathname: '/', previous: '/' },
]

const NavBar = () => {
    const nomeApp = ""
    const { pathname } = useLocation()
    const { push } = useHistory()
    
    const goBack = () => {
        path.map( path => { if (pathname.includes(path.pathname)) push(path.previous) })
    }

    return (
        <React.Fragment>
            <CssBaseline />
            <AppBar position="relative" color="primary">
                <Toolbar >
                    <Link href="https://capivariclube.net.br/"> 
                        <img src={"https://capivariclube.net.br/images/cab/logo.png"}/>
                    </Link>
                    <Grid style={{ width: '80%', marginLeft:"10px" }}>
                        <Typography align="left" variant="h6" color="inherit" noWrap>{ nomeApp }</Typography>
                    </Grid>
                </Toolbar>
            </AppBar>
        </React.Fragment>
    );
}

export default NavBar